'use strict';
import React, { Component } from 'react'
var FormatMessage = require('react-globalize').FormatMessage;

export default class WhatIsElderAbuse extends Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div className="container">
        <div className="row text-justify">

          {
            this.props.locale == "es" ?
            <div className="col-md-12" style={{padding:25}}>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-8">
                  <p style={{fontWeight:"bold"}}>
                    ¿Qué es el abuso al adulto mayor ?
                  </p>
                  <p>
                    Causar o permitir intencionalmente que un anciano o adulto dependiente sufra, o 
                    infligir dolor físico o sufrimiento mental injustificado al anciano o adulto 
                    dependiente.
                  </p>
                  <p style={{fontWeight:"bold"}}>
                  ¿Quién puede ser un abusador potencial?
                  </p>
                  <p>
                  1. Familiar o persona cercana a la persona mayor.<br/>
                  2. Amigo o vecino de la persona mayor.<br/>
                  3. Cualquier otra persona que tenga contacto regular.<br/>
                  4. Alguien más que vive con la persona mayor.<br/>
                  5. Cuidador personal.<br/>


                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/noElderAbuseEs.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-4">
                  <p style={{fontWeight:"bold"}}>
                    Los 7 tipos de abuso al adulto mayores son :
                  </p>
                  <ol>
                    <li>Negligencia.</li>
                    <li>Abuso físico.</li>
                    <li>Abuso Sexual.</li>
                    <li>Abandono.</li>
                    <li>Maltrato emocional o psicológico.</li>
                    <li>Abuso financiero.</li>
                    <li>Auto-descuido.</li>
                  </ol>
                </div>
                <div className="col-md-4">
                  <p style={{fontWeight:"bold"}}>
                    ¿Cómo prevenir el abuso al adulto mayor?
                  </p>
                  <ol>
                    <li>Reporte sospechas de abuso o negligencia tan pronto como sea posible.</li>
                    <li>Cree una comunidad que fomente las conexiones sociales y el apoyo.</li>
                    <li>Comuníquese con los servicios profesionales para obtener ayuda cuando esté disponible.</li>
                    <li>Escuche a las personas mayores y a los cuidadores para comprender sus desafíos y brindarles apoyo.</li>
                    <li>Infórmese unos a otros sobre las señales de abuso y cómo obtener ayuda.</li>
                  </ol>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/elderAbuse/noAbuso2.png" alt="alert" />
                </div>

              </div>
              <div className='row' style={{marginTop:30}}>
                <h4><b>¿Qué es el abuso financiero a personas mayores?</b></h4>
              </div>
              <div className="row" style={{marginTop:50}}>
                <div className="col-md-8">
                  <p>
                    <b>El abuso financiero de personas mayores (también llamado explotación financiera 
                    de personas mayores)</b> es cuando una persona toma o hace un uso indebido del 
                    dinero o los bienes de un adulto mayor para el beneficio de otra persona que no 
                    sea el adulto mayor. <b>El abuso financiero es una forma de abuso de ancianos</b>.
                  </p>

                  <p>
                  <b>¿Quién puede ser un potencial abusador financiero?</b> Vecinos, cuidadores, profesionales e incluso familiares o amigos pueden intentar aprovecharse de las personas a medida que envejecen. Pueden tomar dinero sin permiso, no pagar el dinero que deben, cobrar demasiado por los servicios o no hacer aquello por lo que se les pagó.
                  </p>

                </div>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/elderAbuse/stopElderAbuseEs.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-4">
                  <p style={{fontWeight:"bold"}}>
                    Algunas señales de advertencia de abuso financiero de ancianos:
                  </p>
                  <ol>
                    <li>Falta dinero de las cuentas.</li>
                    <li>Retiros excesivos de efectivo o uso de tarjetas de crédito.</li>
                    <li>Cheques</li>
                    <li>Facturas, recibos o cartas de cobro que se acumulan en el correo.</li>
                    <li>Falta de alimentos y artículos de primera necesidad en el hogar del adulto mayor.</li>
                    <li>Bienes u objetos de valor desaparecidos de la casa de la persona mayor.</li>
                    <li>Un cambio notable en el estado de ánimo o el comportamiento de la persona mayor.</li>
                  </ol>
                </div>
                <div className="col-md-4">
                  <p style={{fontWeight:"bold"}}>
                    ¿Cómo prevenir el abuso financiero de los ancianos?
                  </p>
                  <ol>
                    <li>Date cuenta de que el abuso financiero es real y todos estamos expuestos.</li>
                    <li>Manténgase en contacto y escuche a sus familiares /amigos mayores.</li>
                    <li>Haz un plan financiero que deje en claro qué es normal y qué no con respecto a cómo gastas tu dinero. Y compártelo con la persona en la que puedas confiar.</li>
                    <li>Este pendiente del familiar/amigo que se acerca al adulto mayor en busca de ayuda económica. Hable con su familiar/amigo y edúquelo para que se sienta libre de decir "no". "Después de todo, es su dinero".</li>
                    <li>Revise constantemente su informe de crédito.</li>
                    <li>Reporte sus inquietudes. Si cree que se están aprovechando de alguien o si ve que se están aprovechando de otra persona, comuníquese con la Oficina de Servicios de Protección para Adultos más cercana.</li>
                  </ol>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/elderAbuse/noElderAbuse2.png" alt="alert" />
                </div>
              </div>
            </div> 
            
            :
            
            <div className="col-md-12" style={{padding:25}}>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-8">
                  <p style={{fontWeight:"bold"}}>
                    What is Elder Abuse?
                  </p>
                  <p>
                    Willfully cause or permit an elder or dependent adult to suffer, or inflict 
                    unjustifiable physical pain or mental suffering upon the elder or dependent
                    adult.
                  </p>
                  <p style={{fontWeight:"bold"}}>
                  Who can be a potential abuser?
                  </p>
                  <p>
                  1. Relative or someone close to the older person.<br/>
                  2. Friend or neighbor of the older person.<br/>
                  3. Anyone else who has regular contact.<br/>
                  4. Someone else who lives with the older person.<br/>
                  5. Caretaker, health visitor.<br/>

                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/noElderAbuseEn.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-4">
                  <p style={{fontWeight:"bold"}}>
                    The 7 types of elder abuse are:
                  </p>
                  <ol>
                    <li>Neglect.</li>
                    <li>Physical abuse.</li>
                    <li>Sexual abuse.</li>
                    <li>Abandonment.</li>
                    <li>Emotional or psychological abuse.</li>
                    <li>Financial abuse.</li>
                    <li>Self-neglect.</li>
                  </ol>
                </div>
                <div className="col-md-4">
                  <p style={{fontWeight:"bold"}}>
                    How to Prevent Elder Abuse?
                  </p>
                  <ol>
                    <li>Report suspected abuse or neglect as soon as possible.</li>
                    <li>Build a community that fosters social connections and support.</li>
                    <li>Reach out to professional services for support where available.</li>
                    <li>Listen to older people and caregivers to understand their challenges and provide support.</li>
                    <li>Educate one another about the signs of abuse and how to get help.</li>
                  </ol>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/elderAbuse/elderAbuseEn.png" alt="alert" />
                </div>

              </div>
              <div className='row' style={{marginTop:30}}>
                <h4><b>What Is Elder Financial Abuse?</b></h4>
              </div>
              <div className="row" style={{marginTop:50}}>
                <div className="col-md-8">
                  <p>
                    <b>Elder financial abuse (also called elder financial exploitation)</b> is 
                    when a person takes or misuses an older adult’s money or assets for the benefit of 
                    someone other than the older adult. <b>Financial abuse is a form of elder abuse.</b>.
                  </p>
                  <p>
                  <b>Who can be a potential financial abuser? </b>Neighbors, caregivers, professionals, and even family or friends may try to take advantage of people as they age. They may take money without permission, fail to repay the money they owe, charge too much for services, or not do what they were paid to do.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/elderAbuse/stopElderAbuseEn.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-4">
                  <p style={{fontWeight:"bold"}}>
                    Some warning signs of elder financial abuse:
                  </p>
                  <ol>
                    <li>Money missing from accounts.</li>
                    <li>Excessive cash withdrawals or credit card use.</li>
                    <li>Missing or forged checks.</li>
                    <li>Invoices, bills, or collection letters piling up in the mail.</li>
                    <li>Lack of food and basic necessities in the elder person’s home.</li>
                    <li>Property or valuables going missing from the elder person’s home.</li>
                    <li>A noticeable change in the elder person’s mood or demeanor.</li>
                  </ol>
                </div>
                <div className="col-md-4">
                  <p style={{fontWeight:"bold"}}>
                    How to Prevent Elder Financial Abuse?
                  </p>
                  <ol>
                    <li>Realize that financial abuse is real and we are all exposed.</li>
                    <li>Keep in touch and listen to your older family members/friends.</li>
                    <li>Make a financial plan that makes it clear what is normal and what is not regarding how you spend your money. And share it with the person you can trust.</li>
                    <li>Be aware of the relative/friend who approaches the older adult in search of financial aid. Talk to your family member/friend, and educate them so that they feel free to say "no". "After all, it's your money."</li>
                    <li>Constantly check your credit report.</li>
                    <li>Report your concerns. If you feel someone is being taken advantage of or if you see someone else being taken advantage of, contact the nearest Adult Protective Services Office.</li>
                  </ol>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/elderAbuse/financialAbuseEn.png" alt="alert" />
                </div>
              </div>
            </div> 
            
          }
        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./js/elderAbuseContent/whatIsElderAbuse.js